export default __webpack_public_path__ + "static/media/binary-tree.860908b3.png";